import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "a-switch__form" }
const _hoisted_2 = ["disabled", "checked"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "a-switch__slider" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "a-switch__labelon" }, "ON"),
  /*#__PURE__*/_createElementVNode("span", { class: "a-switch__labeloff" }, "OFF")
], -1)
const _hoisted_4 = {
  key: 0,
  class: "a-switch__label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{
            '-nolabel': !_ctx.state.label || _ctx.state.label.length === 0,
            '-leftlabel': _ctx.state.label && _ctx.state.labelPosition === _ctx.SwitchLabelPosition.Before,
            '-error': _ctx.state.type === _ctx.SwitchType.Error,
            '-info': _ctx.state.type === _ctx.SwitchType.Info,
            '-success': _ctx.state.type === _ctx.SwitchType.Success,
            '-warning': _ctx.state.type === _ctx.SwitchType.Warning,
        }, "a-switch"]),
    onKeydown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleKeyPress && _ctx.handleKeyPress(...args))),
    tabindex: "0"
  }, [
    _createElementVNode("label", _hoisted_1, [
      _createElementVNode("input", {
        disabled: _ctx.state.isDisabled,
        checked: _ctx.state.state,
        onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleSwitchChange($event))),
        class: "a-switch__input",
        type: "checkbox"
      }, null, 40, _hoisted_2),
      _hoisted_3
    ]),
    (_ctx.state.label && _ctx.state.label.length !== 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.state.label), 1))
      : _createCommentVNode("", true)
  ], 34))
}